(() => {
  'use strict';

  const moneyFormat = window.CurrenTheme?.moneyFormat || '${{amount}}';

  function formatMoney(cents, format = moneyFormat) {
    const value = Number(cents || 0);
    const placeholder = /\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?)\s*\}\}/;
    const match = format.match(placeholder);
    if (!match) return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(value / 100);

    let amount;
    switch (match[1]) {
      case 'amount_no_decimals':
        amount = (value / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
        break;
      case 'amount_with_comma_separator':
        amount = (value / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = (value / 100).toLocaleString('de-DE', { maximumFractionDigits: 0 });
        break;
      case 'amount_with_apostrophe_separator':
        amount = (value / 100).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        break;
      default:
        amount = (value / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return format.replace(placeholder, amount);
  }

  function showToast(message, isError = false) {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.toggle('is-error', isError);
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const drawerScrim = document.querySelector('[data-drawer-scrim]');

  function openCartDrawer() {
    if (!cartDrawer || !window.CurrenTheme?.cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (drawerScrim) drawerScrim.hidden = false;
    document.body.classList.add('menu-open');
    cartDrawer.querySelector('[data-drawer-close]')?.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (drawerScrim) drawerScrim.hidden = true;
    document.body.classList.remove('menu-open');
  }

  function renderCartDrawer(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-drawer-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });

    const itemsRoot = document.querySelector('[data-drawer-items]');
    const emptyState = document.querySelector('[data-drawer-empty]');
    const footer = document.querySelector('[data-drawer-footer]');
    const total = document.querySelector('[data-drawer-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (emptyState) emptyState.hidden = cart.item_count > 0;
    if (footer) footer.hidden = cart.item_count === 0;

    const threshold = Number(window.CurrenTheme?.freeShippingThreshold || 0);
    const progress = document.querySelector('[data-shipping-progress]');
    const progressBar = document.querySelector('[data-shipping-bar]');
    const progressMessage = document.querySelector('[data-shipping-message]');
    if (progress && threshold > 0) {
      progress.hidden = false;
      const remaining = Math.max(0, threshold - cart.total_price);
      const percentage = Math.min(100, (cart.total_price / threshold) * 100);
      if (progressBar) progressBar.style.width = `${percentage}%`;
      if (progressMessage) progressMessage.textContent = remaining > 0 ? `Te faltan ${formatMoney(remaining)} para la meta de envío gratis.` : 'Alcanzaste la meta de envío gratis.';
    }

    if (!itemsRoot) return;
    itemsRoot.replaceChildren();
    cart.items.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'drawer-item';
      article.dataset.cartItemKey = item.key;

      const imageLink = document.createElement('a');
      imageLink.className = 'drawer-item__image';
      imageLink.href = item.url;
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title;
        image.loading = 'lazy';
        imageLink.append(image);
      }

      const content = document.createElement('div');
      content.className = 'drawer-item__content';
      const title = document.createElement('a');
      title.className = 'drawer-item__title';
      title.href = item.url;
      title.textContent = item.product_title;
      content.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.textContent = item.variant_title;
        content.append(variant);
      }
      const price = document.createElement('strong');
      price.textContent = formatMoney(item.final_line_price);
      content.append(price);

      const controls = document.createElement('div');
      controls.className = 'drawer-item__controls';
      const makeButton = (label, quantity, className = '') => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.dataset.drawerQuantity = String(quantity);
        button.dataset.cartKey = item.key;
        if (className) button.className = className;
        return button;
      };
      controls.append(makeButton('−', Math.max(0, item.quantity - 1)));
      const quantity = document.createElement('span');
      quantity.textContent = item.quantity;
      controls.append(quantity);
      controls.append(makeButton('+', item.quantity + 1));
      controls.append(makeButton('Eliminar', 0, 'drawer-item__remove'));
      content.append(controls);
      article.append(imageLink, content);
      itemsRoot.append(article);
    });
  }

  async function getCart() {
    const response = await fetch(`${window.CurrenTheme.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No pudimos actualizar el carrito.');
    return response.json();
  }

  document.querySelectorAll('[data-cart-open]').forEach((trigger) => trigger.addEventListener('click', (event) => {
    if (!window.CurrenTheme?.cartDrawer) return;
    event.preventDefault();
    openCartDrawer();
  }));
  document.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', closeCartDrawer));
  drawerScrim?.addEventListener('click', closeCartDrawer);
  if (cartDrawer && Number(window.CurrenTheme?.freeShippingThreshold || 0) > 0) getCart().then(renderCartDrawer).catch(() => {});

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-drawer-quantity]');
    if (!button) return;
    button.disabled = true;
    try {
      const response = await fetch(window.CurrenTheme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: button.dataset.cartKey, quantity: Number(button.dataset.drawerQuantity) })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'No pudimos actualizar el carrito.');
      renderCartDrawer(cart);
    } catch (error) {
      showToast(error.message, true);
      button.disabled = false;
    }
  });

  const searchOverlay = document.querySelector('[data-search-overlay]');
  const openSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
    window.setTimeout(() => searchOverlay.querySelector('[data-search-input]')?.focus(), 60);
  };
  const closeSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
  };
  document.querySelectorAll('[data-search-open]').forEach((trigger) => trigger.addEventListener('click', (event) => { event.preventDefault(); openSearch(); }));
  document.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', closeSearch));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeCartDrawer();
    closeSearch();
    document.querySelector('[data-gallery-lightbox]')?.classList.remove('is-open');
  });

  document.querySelectorAll('[data-announcement]').forEach((root) => {
    const items = [...root.querySelectorAll('[data-announcement-item]')];
    if (items.length < 2) return;
    let index = 0;
    const show = (nextIndex) => {
      index = (nextIndex + items.length) % items.length;
      items.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
      });
    };
    root.querySelector('[data-announcement-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-announcement-next]')?.addEventListener('click', () => show(index + 1));
    const speed = Math.max(3000, Number(root.dataset.speed || 5000));
    let timer = window.setInterval(() => show(index + 1), speed);
    root.addEventListener('mouseenter', () => window.clearInterval(timer));
    root.addEventListener('mouseleave', () => { timer = window.setInterval(() => show(index + 1), speed); });
  });

  document.querySelectorAll('[data-scroll-prev], [data-scroll-next]').forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.scrollPrev || button.dataset.scrollNext;
      const track = document.getElementById(targetId);
      if (!track) return;
      const direction = button.hasAttribute('data-scroll-prev') ? -1 : 1;
      track.scrollBy({ left: direction * Math.max(280, track.clientWidth * .72), behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-close-details]').forEach((button) => {
    button.addEventListener('click', () => {
      const details = button.closest('details');
      if (details) details.open = false;
    });
  });

  document.querySelectorAll('.mobile-menu').forEach((details) => {
    details.addEventListener('toggle', () => document.body.classList.toggle('menu-open', details.open));
    details.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { details.open = false; }));
  });

  document.querySelectorAll('[data-auto-submit]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const items = [...gallery.querySelectorAll('[data-media-id]')];
    const thumbs = [...gallery.querySelectorAll('[data-media-target]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaTarget;
        items.forEach((item) => {
          const active = item.dataset.mediaId === id;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
        });
        thumbs.forEach((candidate) => {
          const active = candidate === thumb;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    if (!form) return;

    const quantityInput = form.querySelector('[data-quantity-input]');
    const quantityChoices = [...form.querySelectorAll('[data-quantity-choice]')];
    const variantSelect = form.querySelector('[data-variant-select]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const addLabel = form.querySelector('[data-add-label]');
    const priceContainer = root.querySelector('[data-product-price]');
    const availability = root.querySelector('[data-availability]');
    const variantChips = [...form.querySelectorAll('[data-variant-chip]')];
    const stickyPurchase = document.querySelector('[data-sticky-purchase]');
    const stickyAdd = document.querySelector('[data-sticky-add]');
    const stickyPrice = document.querySelector('[data-sticky-price]');

    const setQuantity = (value) => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number.parseInt(value, 10) || 1);
      quantityChoices.forEach((button) => button.classList.toggle('is-active', Number(button.dataset.quantityChoice) === Number(quantityInput.value)));
    };

    quantityChoices.forEach((button) => button.addEventListener('click', () => setQuantity(button.dataset.quantityChoice)));
    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => setQuantity(Number(quantityInput.value) - 1));
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => setQuantity(Number(quantityInput.value) + 1));
    quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));

    variantChips.forEach((chip) => chip.addEventListener('click', () => {
      if (!variantSelect || chip.disabled) return;
      variantSelect.value = chip.dataset.variantChip;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }));

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      const price = Number(option?.dataset.price || 0);
      const compare = Number(option?.dataset.comparePrice || 0);

      if (priceContainer) {
        const compareMarkup = compare > price ? `<s class="price__compare">${formatMoney(compare)}</s>` : '';
        priceContainer.innerHTML = `<div class="price${compare > price ? ' price--sale' : ''}"><span class="price__current">${formatMoney(price)}</span>${compareMarkup}</div>`;
      }
      if (availability) {
        availability.classList.toggle('is-unavailable', !available);
        availability.innerHTML = `<span></span>${available ? 'Disponible para comprar' : 'Agotado'}`;
      }
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Agregar al carrito' : 'Agotado';
      variantChips.forEach((chip) => {
        const active = chip.dataset.variantChip === option.value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', String(active));
      });
      if (stickyAdd) stickyAdd.disabled = !available;
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });

    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !window.CurrenTheme?.routes?.cartAdd || event.submitter?.name !== 'add') return;
      event.preventDefault();
      if (addButton?.disabled) return;

      addButton?.setAttribute('aria-busy', 'true');
      if (addLabel) addLabel.textContent = 'Agregando…';

      try {
        const response = await fetch(window.CurrenTheme.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'No pudimos agregar el producto.');

        const cart = await getCart();
        renderCartDrawer(cart);
        showToast('Reloj agregado al carrito.');
        openCartDrawer();
      } catch (error) {
        showToast(error.message || 'Ocurrió un error. Intenta nuevamente.', true);
      } finally {
        addButton?.removeAttribute('aria-busy');
        if (addLabel) addLabel.textContent = addButton?.disabled ? 'Agotado' : 'Agregar al carrito';
      }
    });

    stickyAdd?.addEventListener('click', () => form.requestSubmit(addButton));
    if (stickyPurchase && addButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => stickyPurchase.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .1 });
      observer.observe(addButton);
    }
  });

  document.querySelectorAll('[data-quick-add-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || event.submitter?.name !== 'add') return;
      event.preventDefault();
      const button = form.querySelector('[data-quick-add]');
      button?.setAttribute('aria-busy', 'true');
      if (button) button.textContent = 'Agregando…';
      try {
        const response = await fetch(window.CurrenTheme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'No pudimos agregar el producto.');
        const cart = await getCart();
        renderCartDrawer(cart);
        openCartDrawer();
        showToast('Reloj agregado al carrito.');
      } catch (error) {
        showToast(error.message, true);
      } finally {
        button?.removeAttribute('aria-busy');
        if (button) button.textContent = 'Agregar';
      }
    });
  });

  const galleryLightbox = document.querySelector('[data-gallery-lightbox]');
  const lightboxImage = galleryLightbox?.querySelector('[data-lightbox-image]');
  document.querySelectorAll('[data-gallery-zoom]').forEach((button) => button.addEventListener('click', () => {
    if (!galleryLightbox || !lightboxImage) return;
    lightboxImage.src = button.dataset.imageSrc;
    lightboxImage.alt = button.dataset.imageAlt || '';
    galleryLightbox.classList.add('is-open');
    galleryLightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
  }));
  document.querySelectorAll('[data-lightbox-close]').forEach((button) => button.addEventListener('click', () => {
    if (!galleryLightbox) return;
    galleryLightbox.classList.remove('is-open');
    galleryLightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
  }));

  document.querySelectorAll('[data-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-tab-target]')];
    const panels = [...root.querySelectorAll('[data-tab-panel]')];
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const target = tab.dataset.tabTarget;
      tabs.forEach((candidate) => {
        const active = candidate === tab;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel) => {
        const active = panel.dataset.tabPanel === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    }));
  });

  document.querySelectorAll('product-recommendations[data-url]').forEach(async (element) => {
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('product-recommendations');
      if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
    } catch (_) {
      // Las recomendaciones son complementarias; la compra principal sigue disponible.
    }
  });
})();
